import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Collapse } from "antd";
import ROUTES from "router/NewRoutes";

const Tab = ({ item, counter }) => {
  const [expandCollapsedItem, setExpandCollapsedItem] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (item?.type === "dropdown") {
      const path = location.pathname.slice(1);
      if (
        path === ROUTES.LINKING_ATTRIBUTES ||
        path === ROUTES.ATTRIBUTES_KEYS
      ) {
        setExpandCollapsedItem(true);
      }
    }
  }, [location, item]);

  return item?.type === "dropdown" ? (
    <div className="sidebar__list__tab position-relative">
      <Collapse
        bordered={false}
        activeKey={expandCollapsedItem ? [1] : []}
        className="flex-fill w-100"
        expandIconPosition="end"
        items={[
          {
            id: item.id,
            key: 1,
            label: (
              <TabLabel
                item={item}
                counter={counter}
                dropdown={true}
                handleExpandDropdown={() => {
                  setExpandCollapsedItem(!expandCollapsedItem);
                }}
              />
            ),
            children: (
              <>
                {item.list.map((child) => (
                  <NavLink
                    key={child.id}
                    to={child.link}
                    className="sidebar__list__tab d-flex gap-2 align-items-center py-2"
                  >
                    <div
                      className="sidebar__list__tab__icon"
                      data-strokes-only={item?.fillStrokesOnly}
                    >
                      {child.icon}
                    </div>
                    <span className="sidebar__list__tab__name">
                      {child.name}
                    </span>
                  </NavLink>
                ))}
              </>
            ),
          },
        ]}
      />
    </div>
  ) : (
    <NavLink to={item?.link} className="sidebar__list__tab position-relative">
      <TabLabel item={item} counter={counter} />
    </NavLink>
  );
};

export default Tab;

const TabLabel = ({ item, counter, dropdown, handleExpandDropdown }) => (
  <div
    onClick={() => {
      if (dropdown) handleExpandDropdown();
    }}
    className="d-flex w-100 justify-content-center justify-content-lg-start"
  >
    <div className="position-relative">
      <div
        className="sidebar__list__tab__icon"
        data-strokes-only={item?.fillStrokesOnly}
      >
        {item?.icon}
      </div>
      {counter ? (
        <span className="sidebar__list__tab__counter">
          {counter > 99 ? "99+" : counter}
        </span>
      ) : (
        ""
      )}
    </div>
    <span
      className={`sidebar__list__tab__name ${
        dropdown ? "text--primary-1" : ""
      }`}
    >
      {item?.name}
    </span>
  </div>
);
